import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { getListUnitkerja } from "@/services/getData"
import { Unitkerja } from "@/types"
import { ChevronRight } from "lucide-react"
import React, { useState } from "react"
import { LuListFilter } from "react-icons/lu"
import { useQuery } from "@tanstack/react-query"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

export default function FormFilter({ closeModal }: { closeModal: () => void }) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const idsUk = searchParams.get("uk_ids")

  const [searchQueryProdi, setSearchQueryProdi] = useState("")
  const [selectedFilter, setSelectedFilter] = useState("PRODI")
  const [filter, setFilter] = useState<{
    program_studi: string[]
  }>({
    program_studi: idsUk?.split("-") || [],
  })

  const { data: listUnitkerja, isPending: isPendingListUnitkerja } = useQuery({
    queryKey: ["listUnitkerja"],
    queryFn: getListUnitkerja,
  })
  const listProdi = listUnitkerja?.filter((unitkerja: Unitkerja) => {
    return unitkerja.unitkerja_group_key == "5" && unitkerja.is_active
  })
  const filteredListProdi = listProdi
    ? listProdi.filter((prodi: Unitkerja) => {
        return prodi?.nama
          ?.toLowerCase()
          .includes(searchQueryProdi.toLowerCase())
      })
    : []

  const handleApplyFilter = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (filter.program_studi.length > 0) {
      searchParams.set("uk_ids", filter.program_studi.join("-"))
    } else {
      searchParams.delete("uk_ids")
    }

    closeModal()
    navigate(`${pathname}?${searchParams.toString()}`)
  }

  return (
    <form
      onSubmit={handleApplyFilter}
      className="pb-20 relative flex flex-col gap-y-3"
    >
      <FormHeader title="Filter Data Pendaftaran" icon={<LuListFilter />} />

      <section className="p-3 relative border rounded-xl max-h-[30vh] overflow-auto">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "PRODI" ? "" : "PRODI"))
          }
        >
          <span className="font-bold">Program Studi</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "PRODI" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "PRODI" &&
          (isPendingListUnitkerja ? (
            "Loading..."
          ) : (
            <>
              <div className="py-3 sticky top-0">
                <Input
                  placeholder="Search..."
                  value={searchQueryProdi}
                  onChange={(event) => setSearchQueryProdi(event.target.value)}
                />
              </div>
              <div className="mt-3 grid grid-cols-2 gap-5">
                {filteredListProdi?.map((prodi: Unitkerja) => {
                  const isChecked = (filter.program_studi as string[]).includes(
                    String(prodi.uk_id)
                  )

                  return (
                    <div key={prodi.uk_id} className="flex gap-3">
                      <Checkbox
                        checked={isChecked}
                        onCheckedChange={(checked) => {
                          setFilter((prev) => {
                            const programStudi = [...prev.program_studi]

                            if (checked) {
                              if (!programStudi.includes(String(prodi.uk_id))) {
                                programStudi.push(String(prodi.uk_id))
                              }
                            } else {
                              const index = programStudi.indexOf(
                                String(prodi.uk_id)
                              )
                              if (index > -1) {
                                programStudi.splice(index, 1)
                              }
                            }

                            return {
                              ...prev,
                              program_studi: programStudi,
                            }
                          })
                        }}
                      />
                      <Label>{prodi.nama}</Label>
                    </div>
                  )
                })}
              </div>
            </>
          ))}
      </section>

      <div className="absolute bottom-3 left-3 right-3">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <Button
              onClick={() => closeModal()}
              type="button"
              variant={"outline"}
            >
              Batal
            </Button>
            <Button>Terapkan Filter</Button>
          </div>
          <Button
            type="button"
            variant={"outline"}
            onClick={() => {
              setFilter((prev) => ({
                ...prev,
                program_studi: [],
              }))
              closeModal()
              navigate(`${pathname}`)
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </form>
  )
}
